function handleCvssVersionDropdown() {
  const selector = document.querySelector(".js-cvss-version-selector");
  if (!selector) return;

  const toggle = selector.querySelector(".js-cvss-version-toggle");
  const menu = selector.querySelector("#cvss-version-menu");
  const label = selector.querySelector(".js-cvss-version-label");
  const options = selector.querySelectorAll(".js-cvss-option");
  const v3Section = document.getElementById("cvss-v3-section");
  const v4Section = document.getElementById("cvss-v4-section");

  function setOpen(open) {
    if (!toggle || !menu) return;
    toggle.setAttribute("aria-expanded", open);
    menu.setAttribute("aria-hidden", !open);
  }

  if (toggle) {
    toggle.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const isOpen = toggle.getAttribute("aria-expanded") === "true";
      setOpen(!isOpen);
    });
  }

  options.forEach((option) => {
    option.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const version = option.dataset.cvss;
      label.textContent = option.textContent;
      setOpen(false);

      if (version === "v4") {
        v4Section && v4Section.classList.remove("u-hide");
        v3Section && v3Section.classList.add("u-hide");
      } else {
        v3Section && v3Section.classList.remove("u-hide");
        v4Section && v4Section.classList.add("u-hide");
      }
    });
  });

  document.addEventListener("click", (event) => {
    if (!selector.contains(event.target)) {
      setOpen(false);
    }
  });
}
handleCvssVersionDropdown();
